import { IconButton } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RequestCard from "./RequestCard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStripe } from "@stripe/react-stripe-js";
import { useIds } from "../../hook/AdminContext";
import CardInformation from "./CardInformdation";
import { upgrade_plan } from "../../DAL/PaymentRequest/paymentRequest";
import { convertCurrencyToSignNew } from "../../utils/Constant";
const PendingRequests = ({ paymentRequest }) => {
  const { fetctUserDetail, userInfo } = useIds();
  const location = useLocation();
  const navigate = useNavigate();
  const stripe = useStripe();
  const [requestData, setRequestData] = useState(paymentRequest);
  const [isLoadingCard, setIsLoadingCard] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [resPostData, setResPostData] = useState("");

  const { enqueueSnackbar } = useSnackbar();

  const handleShowThanks = () => {
    navigate(`/payment-done/${requestData._id}`, { state: requestData });
  };

  function test(words) {
    var n = words.split("=");
    return n[n.length - 1];
  }
  let mobileView = test(location.search);

  const handleSecureCard = (client_secret, cardElement, postData) => {
    enqueueSnackbar("Processing card...", {
      variant: "info",
    });

    stripe
      .confirmCardPayment(client_secret, {
        payment_method: {
          card: cardElement,
        },
      })
      .then(function (result) {
        // Handle result.error or result.paymentIntent
        setIsLoadingCard(false);
        if (result.error) {
          setIsLoadingCard(false);
          enqueueSnackbar(result.error.message, { variant: "error" });
          return;
        }

        enqueueSnackbar("Payment succeeded successfully.", {
          variant: "success",
        });
        setTimeout(() => {
          fetctUserDetail();
        }, 5000);
        handleShowThanks();
      })
      .catch((err) => {
        enqueueSnackbar(err.message, { variant: "error" });
      });
  };

  function calculateChargeableAmount(name = "initial_amount") {
    const bill = requestData;
    let baseAmount = 0;

    if (bill.plan.payment_access === "onetime") {
      baseAmount = bill.plan.total_amount;
    } else if (bill.plan.payment_access === "recursion") {
      baseAmount = bill.plan[name];
    }

    if (baseAmount <= 0) return 0;

    const vatAmount =
      bill.plan.vat_percentage > 0
        ? (baseAmount * bill.plan.vat_percentage) / 100
        : 0;

    const chargeableAmount = baseAmount + vatAmount;

    return parseFloat(chargeableAmount.toFixed(2));
  }

  const handleMakePayment = async (card_token, cardElement) => {
    const postData = {
      source_token: card_token,
      plan_id: requestData.plan._id,
      client_id: userInfo._id,
      payment_request_id: requestData._id,
    };

    const resp = await upgrade_plan(postData);
    if (resp.code == 200 || resp.code == 210) {
      if (resp?.data?.payment_response?.client_secret) {
        handleSecureCard(
          resp.data?.payment_response?.client_secret,
          cardElement
        );
      } else {
        enqueueSnackbar("Payment succeeded successfully.", {
          variant: "success",
        });
        setTimeout(() => {
          fetctUserDetail();
        }, 5000);
        handleShowThanks();
      }
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
      setIsLoadingCard(false);
    }
  };

  const calculate_vat = (bill) => {
    const vat_amount =
      bill.plan.initial_amount * Number(bill.plan.vat_percentage / 100);
    return vat_amount.toFixed(2);
  };

  useEffect(() => {
    setRequestData(paymentRequest);
  }, [paymentRequest]);
  return (
    <div className="container mt-2">
      <div className="d-flex align-items-center mb-2">
        {mobileView == "mobile" ? (
          ""
        ) : (
          <span>
            <IconButton
              className="back-screen-button"
              onClick={() => navigate("/payment-requests")}
            >
              <ArrowBackIcon />
            </IconButton>
          </span>
        )}
        <h3 className="mb-0 ms-2">Make Payment</h3>
      </div>

      {/* <RequestCard
        bill={requestData}
        showChargeAbleAmount={true}
        isDetailShow={true}
      /> */}
      <div className="card-1">
        <div className="row">
          <div className="col-12 col-xl-6">
            <div className="payment-left-side p-4">
              <h4>Payment Info</h4>

              {requestData.plan.trial_period_days > 0 && (
                <div className="make-payment-label-value mt-3">
                  <div className="label">Trial Period</div>
                  <div className="value">
                    {requestData.plan.trial_period_days} Days
                  </div>
                </div>
              )}
              {requestData.plan.initial_amount && (
                <div className="make-payment-label-value mt-3">
                  <div className="label">Initial Amount</div>
                  <div className="value">
                    {requestData.plan.trial_period_days > 0 && (
                      <span className="label" style={{ fontSize: 12 }}>
                        (after the {requestData.plan.trial_period_days}-day
                        trial)
                      </span>
                    )}{" "}
                    {convertCurrencyToSignNew(requestData.plan.plan_currency)}
                    {requestData.plan.initial_amount}
                  </div>
                </div>
              )}
              <div className="make-payment-label-value mt-3">
                <div className="label">Subscription Amount</div>
                <div className="value">
                  <span className="label" style={{ fontSize: 12 }}>
                    (Excluding VAT)
                  </span>{" "}
                  {convertCurrencyToSignNew(requestData.plan.plan_currency)}
                  {requestData.plan.recurring_amount}
                </div>
              </div>
              <div className="make-payment-label-value mt-3">
                <div className="label">VAT Amount</div>
                <div className="value">
                  {requestData.plan.vat_percentage
                    ? requestData.plan.vat_percentage
                    : "0"}
                  %{" "}
                  <span className="label">
                    ({convertCurrencyToSignNew(requestData.plan.plan_currency)}
                    {calculate_vat(requestData)})
                  </span>
                </div>
              </div>
              <div className="make-payment-label-value mt-3">
                <div className="label">Sub Total</div>
                <div className="value">
                  <span className="label">
                    {convertCurrencyToSignNew(requestData.plan.plan_currency)}
                    {requestData.plan.initial_amount} +{" "}
                    {requestData.plan.vat_percentage
                      ? requestData.plan.vat_percentage
                      : "0"}
                    % (
                    {convertCurrencyToSignNew(requestData.plan.plan_currency) +
                      calculate_vat(requestData)}
                    )
                  </span>
                </div>
              </div>
              <div className="border-top mt-3"> </div>
              <div className="make-payment-total mt-4 py-3 px-4">
                <div className="make-payment-label-value">
                  <div className="label">Total Payable Today</div>
                  <div className="value" style={{ fontWeight: 600 }}>
                    {convertCurrencyToSignNew(requestData.plan.plan_currency)}
                    {requestData.plan.trial_period_days > 0 &&
                    requestData.payment_request_type == "pending"
                      ? "0"
                      : calculateChargeableAmount()}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-xl-6 p-4">
            <div className="make-payment-right p-4">
              <CardInformation
                isLoading={isLoadingCard}
                setIsLoading={setIsLoadingCard}
                handleCardAction={handleMakePayment}
                headingTitle={"Payment Method"}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className={`col-12`}></div>
      </div>
    </div>
  );
};

export default PendingRequests;
